let swipers = {
    advantages: globalSwipers.advantages
};

let rangeSliders = {};

function renderMultiselect() {
    $('.js-multiselect').not('.is-loaded').multiselect({
        templates: {
            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><i aria-hidden="true" class="ico ico-chevron-down"></i><span class="multiselect-selected-text"></span></button>'
        },
        buttonClass: 'c-btn c-btn--transparent',
        enableHTML: true
    });
    $('.js-multiselect').addClass('is-loaded');

    $('.js-multiselect-order').not('.is-loadeed').multiselect({
        templates: {
            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><i aria-hidden="true" class="ico ico-chevron-down"></i><span class="multiselect-selected-text"></span></button>'
        },
        buttonClass: 'c-btn c-btn--transparent',
        enableHTML: true,
        buttonText: function(options, select) {
            const $orderSelect = $('.js-multiselect-order'),
                selectedValue = $(options).text(),
                emptyTitle = $orderSelect.data('empty-title'),
                isFiltered = $orderSelect.data('is-filtered'),
                isLoaded = $orderSelect.hasClass('is-loaded');

            let buttonTitle = selectedValue;

            if (!isLoaded && !isFiltered) {
                buttonTitle = emptyTitle;
            }

            return buttonTitle;
        }
    });
    $('.js-multiselect-order').addClass('is-loaded');
}

function createRangeSliders() {
    $('.js-range-price').each(function () {
        const $elem = $(this),
            $slider = $elem.find('.range-slider__slider'),
            maxValue = Number($elem.attr('data-max')),
            minValue = Number($elem.attr('data-min')),
            tooltipSuffix = $elem.attr('data-suffix'),
            tooltipPrefix = $elem.attr('data-prefix'),
            input = $elem.attr('data-input'),
            inputIsSet = !$elem.hasClass('is-initialized'),
            defaultValue = inputIsSet ? $('#' + input).val() : (maxValue + minValue) / 2;

        rangeSliders[input] = noUiSlider.create($slider[0], {
            start: [defaultValue],
            range: {
                'min': [minValue],
                'max': [maxValue]
            },
            connect: [true, false],
            tooltips: [wNumb({
                decimals: 0,
                prefix: '<span class="prefix">' + tooltipPrefix + '</span>',
                suffix: '<span class="suffix">' + tooltipSuffix + '</span>'
            })],
            step: 1
        });

        rangeSliders[input].on('change', function (values, handle) {
            $('#' + input).val(values[handle]).trigger('change');
            $elem.find('.range-slider__value').text(parseInt(values[handle]) + tooltipSuffix);

            if ($elem.hasClass('is-initialized')) {
                $elem.removeClass('is-initialized');
            }
        });

        rangeSliders[input].on('start', function (values, handle) {
            if ($elem.hasClass('is-initialized')) {
                $elem.removeClass('is-initialized');
            }
        });
    });
}

function toggleVariations() {
    var $checkedBaseVariations = $("input[name=\"base_variation\"]:checked"),
        $checkedManufacturers = $("input[name=\"filter[manufacturers][]\"]:checked"),
        checkedManufacturers = [],
        $baseColors = $("input[name=\"base_variation\"]"),
        $colorVariations = $("input[name=\"filter[variations][1][]\"]");

    $colorVariations.parents(".c-form__item").show();

    if ($checkedBaseVariations.size() > 0) {
        $colorVariations.parents(".c-form__item").hide();

        $checkedBaseVariations.each(function () {
            var value = $(this).val();

            $colorVariations.filter(function () {
                return $(this).data("color-" + value) == "1";
            }).parents(".c-form__item").show();
        });
    } else {
        $colorVariations.parents(".c-form__item").show();
    }

    if (!$checkedManufacturers.size()) {
        return;
    }

    $checkedManufacturers.each(function () {
        checkedManufacturers.push(parseInt($(this).val()));
    });

    $hideVariations = $colorVariations.filter(function () {
        return parseInt($(this).data("manufacturer")) > 0 && checkedManufacturers.indexOf($(this).data("manufacturer")) == -1;
    });
    $hideVariations.parents(".c-form__item").hide();
    $hideVariations.find(":checked").prop("checked", false).trigger("change");

    $baseColors.each(function () {
        var $this = $(this);
        $availableVariations = $colorVariations.filter(function () {
            return (parseInt($(this).data("manufacturer")) == 0 || checkedManufacturers.indexOf($(this).data("manufacturer")) != -1) && $(this).data("color-" + $this.val()) == 1;
        });

        if ($availableVariations.size() == 0) {
            $(this).parents(".c-form__item").hide();
        }
    });

    $baseColors.parents(".c-form__item").show();
}

function toggleColors() {
    if ($('[name="base_variation"]').is(':checked')) {
        $('.tab__colors__wrapper').show();
    } else {
        $('.tab__colors__wrapper').hide();
    }
}

function toggleFilter() {
    const $subFilter = $('.js-target-filter'),
        $subFilterTrigger = $('.js-trigger-filter'),
        $triggerIcon = $('.js-filter-icon'),
        $filterWrapper = $('.js-filter-wrapper');

    if ($subFilter.hasClass('is-active')) {
        $subFilter.removeClass('is-active');
        $subFilterTrigger.removeClass('is-active');
        $filterWrapper.removeClass('is-open');

        $triggerIcon.removeClass('ico-cross');
        $triggerIcon.addClass('ico-filter');

        if (checkResolution('cxs;xs')) {
            $subFilter.hide();
            $('body').css('overflow', '');
        } else {
            $subFilter.slideUp(200);
        }
    }
    else {
        $subFilter.addClass('is-active');
        $subFilterTrigger.addClass('is-active');
        $filterWrapper.addClass('is-open');

        $triggerIcon.removeClass('ico-filter');
        $triggerIcon.addClass('ico-cross');

        if (checkResolution('cxs;xs')) {
            $subFilter.show();
            $('body').css('overflow', 'hidden');
        } else {
            $subFilter.slideDown(200);
        }
    }
}

function updateFilterBubbles() {
    const $bubblesItems = $('.js-filter-bubbles-item'),
        $bubblesReset = $('.js-filter-bubbles-reset'),
        $bubblesWrapper = $('.js-filter-bubbles-wrapper');

    $bubblesWrapper.data('count', $bubblesItems.length);

    if ($bubblesItems.length < 1) {
        $bubblesReset.remove();
        $bubblesWrapper.removeClass('is-visible');
    } else {
        $bubblesWrapper.addClass('is-visible');
    }
}

rEvent.on('FilterBubbles.created', function() {
    updateFilterBubbles();
});

rEvent.on('FilterBubbles.added', function() {
    updateFilterBubbles();
});

function filterManufacturers() {
    const $brandsWrapper = $('.js-filter-brands-wrapper'),
        $checkedManufacturers = $('input[name="filter[manufacturers][]"]:checked'),
        checkedManufacturers = [];

    let areBrandsVisible = false;

    $checkedManufacturers.each(function () {
        checkedManufacturers.push(parseInt($(this).data('manufacturer-id')));
    });

    $brandsWrapper.find('input[name="filter[brands][]"]').each(function() {
        const isActive = checkedManufacturers.indexOf($(this).data('manufacturer-id')) !== -1;

        if (isActive) {
            areBrandsVisible = true;
        }

        $(this).parent().toggleClass('hidden', !isActive);

        if ($(this).is(':checked') && !isActive) {
            $(this).prop('checked', false);
        }
    });

    $brandsWrapper.toggleClass('h-nodisplay', !areBrandsVisible);

    Filter.refreshBubbles()
    updateFilterBubbles();
}

rEvent.on('Listing.fetchedData', function(data) {
    hidePreloader();
});

Listing.customCallbacks.beforeFetch = function() {
    showPreloader();
};

$(function() {
    checkSliders(swipers);
    renderMultiselect();
    createRangeSliders();
    toggleColors();

    if (!$('.js-filter-brands-wrapper').hasClass('without-manufacturers')) {
        filterManufacturers();
    }

    tippy('.js-properties-tippy', {
        arrow: true,
        theme: 'filter',
        performance: true,
        maxWidth: 'calc(100% - 30px)'
    });

    $(window).on('resize', function () {
        checkSliders(swipers);
    });

    $('.js-trigger-filter, .js-close-filter').on('click', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('is-disabled')) {
            toggleFilter();
        }
    });

    $('.js-filter-show-results').on('click', function() {
        toggleFilter();
    });

    $("input[name=\"base_variation\"], input[name=\"filter[manufacturers][]\"]").bind("change", function () {
        toggleVariations();
    });

    $("[name=\"base_variation\"]").bind("change", function () {
        toggleColors();

        setTimeout(function () {
            $(".tab__colors__wrapper [type=\"checkbox\"]:checked:hidden").prop("checked", false).trigger("change");
        }, 150);
    });

    $('body').on('change', '.filter__form [type="checkbox"]', function() {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function() {
        updateFilterBubbles();

        setTimeout(function() {
            updateFilterBubbles();
        }, 1);
    });

    $('body').on('click', '.js-filter-bubbles-reset', function() {
        var $rangePrice = $('.js-range-price'),
            maxValue = Number($rangePrice.attr('data-max')),
            minValue = Number($rangePrice.attr('data-min'));

        $('.js-filter-reset-button').click();

        updateFilterBubbles();

        setTimeout(function() {
            updateFilterBubbles();
        }, 1);

        $rangePrice.addClass('is-initialized');
        $rangePrice.find('.range-slider__slider')[0].noUiSlider.set((maxValue + minValue) / 2);
    });

    $('input[name="filter[manufacturers][]"]').on('change', function() {
        filterManufacturers();
    });
});
